import { getRangeSensitivityWorkbookKey } from 'pages/ValuationsAllocation/approaches/RangeSensitivity/constants';
import {
  EQUITY_ALLOCATION_KEY,
  EQUITY_ALLOCATION_LABEL,
} from 'pages/ValuationsAllocation/common/constants/equityAllocation';
import {
  VALUATION_SUMMARY_KEY,
  VALUATION_SUMMARY_LABEL,
} from 'pages/ValuationsAllocation/common/constants/valuationSummary';
import { ALLOCATION_WEIGHTED_SHARE_VALUES_LABEL } from 'pages/ValuationsAllocation/common/constants/weightedShareValues';
import { valuationTabId } from 'pages/ValuationsAllocation/common/utils/valuationTabId';
import { SlimApproachTable, SlimApproachTables } from 'pages/ValuationsAllocation/types';
import { getApproachTableName } from 'pages/ValuationsAllocation/util/getApproachTableName';
import { getObjectValue, getStringValue } from 'utilities';
import { GetTableNamesParams } from './types';

const getTableNames = (params: GetTableNamesParams): SlimApproachTables => {
  const { approaches, rangeSensitivities, weightedShareValuesNames } = params;

  const valuationSummaryTable = {
    [VALUATION_SUMMARY_KEY]: {
      approachType: '',
      id: VALUATION_SUMMARY_KEY,
      name: VALUATION_SUMMARY_LABEL,
    } as SlimApproachTable,
  } as SlimApproachTables;

  const equityAllocationTable = {
    [EQUITY_ALLOCATION_KEY]: {
      approachType: '',
      id: VALUATION_SUMMARY_KEY,
      name: EQUITY_ALLOCATION_LABEL,
    } as SlimApproachTable,
  } as SlimApproachTables;

  const weightedShareValuesTables = getObjectValue(
    weightedShareValuesNames.reduce((accumulator, current) => {
      const weightedShareValueName = getStringValue(current);

      return {
        ...accumulator,
        [weightedShareValueName]: {
          approachType: '',
          id: VALUATION_SUMMARY_KEY,
          name: ALLOCATION_WEIGHTED_SHARE_VALUES_LABEL,
        } as SlimApproachTable,
      };
    }, {} as SlimApproachTables)
  );

  const approachesTables = getObjectValue(
    approaches?.reduce((accumulator, current) => {
      const { approach_type: approachType, name } = current;
      const approachTableName = getApproachTableName({ approach: current });

      return {
        ...accumulator,
        [approachTableName]: {
          approachType: getStringValue(approachType),
          id: valuationTabId('approach', approachTableName),
          name: getStringValue(name),
        } as SlimApproachTable,
      };
    }, {} as SlimApproachTables)
  );

  const rangeSensitivityTables = getObjectValue(
    (rangeSensitivities ?? []).reduce((accumulator, rs) => {
      const panelId = getStringValue((rs as { panelId?: string }).panelId ?? rs.panel_id);
      const workbookKey = getRangeSensitivityWorkbookKey(panelId);

      return {
        ...accumulator,
        [workbookKey]: {
          approachType: '',
          id: valuationTabId('range_sensitivity', panelId),
          name: getStringValue(rs.name),
        },
      };
    }, {} as SlimApproachTables)
  );

  return {
    ...valuationSummaryTable,
    ...equityAllocationTable,
    ...weightedShareValuesTables,
    ...approachesTables,
    ...rangeSensitivityTables,
  } as SlimApproachTables;
};

export default getTableNames;
